import notification from "./notification";
import loading from "./loading";
import { PERMISSIONS } from "@/utils/constants";

export default {
  install(Vue) {
    Vue.mixin(notification);
    Vue.mixin(loading);
    Vue.prototype.$permissions = PERMISSIONS;
    Vue.prototype.console = console;
  },
};
